/**
 * Development-only logger utility
 * Only logs in development mode to keep production console clean
 */

const isDevelopment = process.env.NODE_ENV === 'development';

// Create a logger object that only logs in development
export const logger = {
  // Important info that should always be visible in dev
  info: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  // Warnings that should always be visible
  warn: (...args) => {
    console.warn(...args);
  },

  // Errors that should always be visible
  error: (...args) => {
    console.error(...args);
  },

  // Debug logs that are only visible in development
  debug: (...args) => {
    if (isDevelopment) {
      console.log('🔍', ...args);
    }
  },

  // Performance logs that are only visible in development
  perf: (...args) => {
    if (isDevelopment) {
      console.log('⚡', ...args);
    }
  },

  // Model loading logs that are only visible in development
  model: (...args) => {
    if (isDevelopment) {
      console.log('📦', ...args);
    }
  },

  // Animation logs that are only visible in development
  animation: (...args) => {
    if (isDevelopment) {
      console.log('🎬', ...args);
    }
  },

  // Audio logs that are only visible in development
  audio: (...args) => {
    if (isDevelopment) {
      console.log('🔊', ...args);
    }
  },

  // Scene logs that are only visible in development
  scene: (...args) => {
    if (isDevelopment) {
      console.log('🎭', ...args);
    }
  },

  // GPU/Performance logs that are only visible in development
  gpu: (...args) => {
    if (isDevelopment) {
      console.log('🖥️', ...args);
    }
  }
};

export default logger;
